import React, { useState } from "react";
import styled from "styled-components";
import DaumPostcode from "react-daum-postcode";

interface Props {
  onSelect: (addr: { address: string; zipCode: string }) => void;
  onClose: () => void;
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: bold;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

export default function AddressModal({ onClose, onSelect }: Props) {
  const handleComplete = (data: any) => {
    const fullAddress = data.address;
    const zipCode = data.zonecode;

    onSelect({ address: fullAddress, zipCode }); // ✅ 객체로 넘김
    onClose();
  };

  return (
    <Container>
      <Header>
        주소 검색
        <CloseButton onClick={onClose}>×</CloseButton>
      </Header>
      <DaumPostcode
        style={{ width: "100%", height: "100%" }}
        onComplete={handleComplete}
      />
    </Container>
  );
}
